import LFOsTrack from "track/LFOsTrack.js";
import EnvelopesTrack from "track/EnvelopesTrack.js";
import ParameterContext from "effects/ParameterContext.js";

export default superclass => class extends superclass  {
    initModulators() {
        this.lfosTrack = new LFOsTrack(this.sequencerEngine, this.subSequence, new ParameterContext().forTrack(this));
        this.envelopesTrack = new EnvelopesTrack(this.sequencerEngine, this.subSequence);

    }

    get hasModulators() {
        return true;
    }
}
